import { useState } from "react";

import { classNames } from "primereact/utils";

export default function ModuleAccordion({ data }) {
  const [expand, setExpand] = useState(null);

  const expandAction = (serial) => {
    let tempExpand = { ...(expand ? expand : {}) };
    tempExpand[serial] = !tempExpand[serial];
    setExpand(tempExpand);
  };

  return (
    <>
      <div className="expand-wrap">
        {data.map((item, index) => (
          <div
            key={`accordion_${index}`}
            className={classNames(
              "expand-item border-bottom-1 border-400 p-3",
              {
                "mt-2": index !== 0,
                "expand-active": expand && expand[index] === true,
              }
            )}
          >
            <div
              className="expand-head flex align-items-start hover:text-main cursor-pointer mb-2"
              onClick={() => expandAction(index)}
            >
              <div
                className="flex align-items-center justify-content-center flex-shrink-0 text-xl text-white font-bold bg-red-500 border-circle"
                style={{ width: "2.5rem", height: "2.5rem" }}
              >{`Q${index + 1}`}</div>
              <span className="text-2xl font-bold ml-2 mt-1">{item.title}</span>
            </div>
            <div
              className={classNames(
                "expand-body overflow-hidden animation-duration-1000",
                {
                  slideup: expand && expand[index] === false,
                  slidedown: expand && expand[index] === true,
                }
              )}
            >
              <div className="text-lg white-space-prewrap line-height-4 bg-gray-200 border-round-md p-3 md:ml-6">
                {item.contentTemplate
                  ? item.contentTemplate
                  : typeof item.content === "object"
                  ? item.content.map((content, cIdx) => (
                      <div key={`qa_${index}_${cIdx}`}>{content}</div>
                    ))
                  : item.content}
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
